/*eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Modal,
  Form as FormUi,
  Icon,
  Dropdown,
} from "semantic-ui-react";
import { withFormik, Field as Fieldmik, FieldArray, ErrorMessage } from "formik";
import ReadAxios from "../../axiosComponent/read";
import { isEmpty } from "lodash";
import CreateAxios from "../../axiosComponent/create";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { translate } from "react-i18next";
import cogoToast from "cogo-toast";
import * as Yup from "yup";
import { isAnyBidEnable } from "../../../features/features";
import { TOAST_MESSAGES } from "../../../utils/toastMsgConstant";
import { MyNormalInput } from "../../dynamicComponent/myInputs";
import { FEATURES, LOCAL_STORAGE } from "../../../utils/constant";
import { PROMPTS } from "../../../utils/validationConstant";

const ModalInterested = ({ values, isSubmitting, handleSubmit, setFieldValue, t, props, bid, uom, bid_amount, touched,errors, captchaReload }) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [Vendors, setVendors] = useState([]);
  const [submitForm, setsubmitForm] = useState(true);
  const [captchaImage , setCaptchaImage] = useState("")
  const [captchaFetched, setCaptchaFetched] = useState(false)
  const [captchaNote, setCaptchaNote] = useState("")

  useEffect(() => {
    getAllVendors();
  }, [props?.orderDetail]);

  useEffect(() => {
    captchaReload && getCaptchaImage()
    captchaReload && setFieldValue("captcha_answer","")
  }, [captchaReload]);

  let handleOpen = () => {
    setmodalOpen(true);
    getCaptchaImage()
  }
  let handleClose = () => {
    setmodalOpen(false);
  };
  
  let getCaptchaImage = async ()=>{
    setCaptchaFetched(false)
    ReadAxios({completeURL:`${process.env.REACT_APP_TA_API_URL}/orders/fetch/captcha`}).then((res)=>{
      if(res.data.status===1){
        setCaptchaImage(res.data.captcha)
        setCaptchaNote(res.data.captcha_note)
        setFieldValue("captcha_token",res.data.captcha_token)
        setCaptchaFetched(true)
      }
    }).catch((err)=>{
      console.log(err);
    })
  }
  let handleSubmited = async() => {
        if (values.available_vehicle_type) handleSubmit();    
  };

  const getAllVendors = () => {
    CreateAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/vehicleTypeMaster` })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setVendors([])
          : setVendorsState(res.data.resultSet);
      })
      .catch((err) => setVendors([]));
  };
  const setVendorsState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        text: item.vehicleType,
        key: item.vehicleTypeCode,
        value: item.vehicleTypeId,
      };
    });
    setVendors(result);
  };

  let handlebidrate = (bid_rate) => {
    if (!isAnyBidEnable(localStorage.getItem('customerNumber')) && bid_rate > +bid_amount) {
      (
        setmodalOpen(true),
        cogoToast.error("Bid amount shoud be less than offered rate")),
        setsubmitForm(false)
    }
    else {
      setsubmitForm(true)
    }
  };

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        size="mini"
        trigger={
          <Button
            type="button"
            onClick={handleOpen}
            size="mini"
            basic color="blue"
            className="p-bold-600"
          >
            {t("show_interest") || "Show Interest"}
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">
          <div className="d-flex justify-content-between">
            <label className="font-weight-normal">{t("show_interest") || "Show Interest"}</label>
            <div className="form-inline">
              <i onClick={handleClose} className="fas fa-times"></i>
            </div>
          </div>
        </Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description>
            <div className="ui form p-2">
              <FormUi.Field>
                <label className="labelName"> {t("vehicle_type") || "Vehicle Type"}</label>
              </FormUi.Field>
              <Dropdown
                name="available_vehicle_type"
                disabled={localStorage.getItem('customerNumber') == 1166 ? true : false}
                clearable
                search
                style={{ width: "100%" }}
                selection
                placeholder={values.available_vehicle_name}
                onChange={(name, data) => setFieldValue("available_vehicle_type", data.value)}
                options={Vendors}
              //defaultValue={values.available_vehicle_type}
              />
              <ErrorMessage name="available_vehicle_type" />

              {bid == true ?
                <>
                  <FormUi.Field className="mt-4">
                    <label className="labelName">{t("bid_rate") + " per " + uom || "Bid Rate per" + uom} </label>
                  </FormUi.Field>
                  <FormUi.Field>
                    <Fieldmik name="bid_rate" onKeyUp={() => { handlebidrate(values.bid_rate) }} />
                    {/* <ErrorMessage name="bid_rate" /> */}
                    {touched.bid_rate && errors.bid_rate && 
                    <small className="text-danger">{errors.bid_rate}</small>
                    }
                  </FormUi.Field>
                </>
                : ""}
                 {FEATURES.isCaptchaOptional ? "" : 
                 captchaImage &&
                 <div className="row mt-3">
                <div>
                 <div className="mr-2" dangerouslySetInnerHTML={{ __html: captchaImage }} />
                 <small className="ml-3">{captchaNote||"Solve this captcha to continue"}</small>
                </div>
                 <Button className="w3-round p-0 pl-2 pr-2 ui basic button" onClick={getCaptchaImage}><Icon className="large m-0" name={captchaFetched ? "redo alternate" : "loading spinner"} /></Button>
                 <FormUi.Field className="mt-2 ml-3" width={12}>
                 <Fieldmik component={MyNormalInput} name="captcha_answer" placeholder="Enter Captcha Result" maxLength={10} />
                 {touched.captcha_answer && errors.captcha_answer && 
                    <small className="text-danger">{errors.captcha_answer}</small>
                    }
                 </FormUi.Field>
                 </div>}
            </div>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            type="submit"
            onClick={handleSubmited}
            disabled={isSubmitting ? true : (submitForm == true ? false : true)}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
            onHover={() => { handlebidrate(values.bid_rate) }}
          >
            {isSubmitting ? <Icon className="large m-0" name="loading spinner"/> : (t("action_button.submit") || "Submit")}
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};
const FormikInterested = withFormik({
  mapPropsToValues(props) {
    return {
      available_vehicle_type: props?.orderDetail?.proposed_vehicle_type ? props.orderDetail.proposed_vehicle_type : '',
      available_vehicle_name: props?.orderDetail?.vehicle_type ? props.orderDetail.vehicle_type : '',
      bid_rate: "",
      captcha_answer:"",
      captcha_token:"",
      isLoading :false
    };
  },
  validationSchema: (props) => {
    return (
      Yup.object().shape({
    available_vehicle_type: Yup.string().required("Vehicle type Required"),
    bid_rate : props.bid ? Yup.string().required("Bid rate Required") : Yup.string().optional().nullable(),
    captcha_answer : FEATURES.isCaptchaOptional ? Yup.string().optional().nullable() : Yup.string().required("Required"),
  })
  )},
  handleSubmit(values, { setSubmitting, props , resetForm}) {
    let orderId = window.location.search.split("=")[1];
    let vendorId = localStorage.getItem("vendorId")
    let bid_amount = values.bid_rate
    let headersExtra = {captcha_token : values.captcha_token}
    setSubmitting(true)
    CreateAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${orderId}/broadcast/vendor/${vendorId}/interest`, payload: values,headersExtra
    })
      .then((res) => {
        console.log(res);
        if(res.data.status===1){
          props.successAlertDispatcher({
            type: "success",
            messageHeader: "Success",
            messageBody: res.data.message,
          });
          window.location.reload();
        }else{
          setSubmitting(false);
          props.reloadCaptcha()
          props.errorAlertDispatcher({
            type: "error",
            messageHeader: "Error",
            messageBody: res.data.message,
          });
        }
      })
      .catch((err) => {
        setSubmitting(false);
        props.reloadCaptcha()
        props.successAlertDispatcher({
          type: "error",
          messageHeader: "Error",
          messageBody: err?.response?.data?.message || err.message,
        });
      });
  },
})(ModalInterested);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("allot")(FormikInterested)
);
